// extracted by mini-css-extract-plugin
export default {"navItem":"DashboardNavItem_navItem__pQhVc","link":"DashboardNavItem_link__ednS0","tipBoxContainer":"DashboardNavItem_tipBoxContainer__SHWRZ","hover":"DashboardNavItem_hover__cjbV5"};